import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class Sample extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sample: 'Loading.....',
			codeType: 'language-javascript'
		};
	}

	async componentDidMount() {
		// __APIEXAMPLEPATHS__ is a global variable from the webpack config
		// eslint-disable-next-line no-undef
		const paths = __APIEXAMPLEPATHS__;

		try {
			let urlPath;
			let codeType = 'language-javascript';
			const apiItem = this.props.apiItem;

			if (apiItem.example) {
				this.setState({ sample: apiItem.example, codeType: codeType });
			}
			else {
				const isQuery = this.isQuery();
				if (isQuery) {
					urlPath = `/${paths.samplesPath}/query/${apiItem.name}Sample.txt`;
					codeType = 'language-http';
				}
				else {
					urlPath = `/${paths.samplesPath}/json/${apiItem.name}Sample.json`;
				}

				const resp = await fetch(urlPath);
				const data = await resp.text();

				if (!isQuery) {
					// This throws an error if it isn't json
					JSON.parse(data);
				}

				this.setState({ sample: data, codeType: codeType });
			}
		} catch (err) {
			this.setState({ ...this.state, sample: 'Unable to fetch sample' });
		}
	}

	isQuery = () => {
		const selectedRoute = this.props.categories.map(cat => {
			return cat.routes;
		}).reduce((routeSet, route) => {
			return [...routeSet, ...route];
		}).find(route => {
			return route.request.name === this.props.apiItem.name;
		});

		if (selectedRoute) {
			var filtered = selectedRoute.verbs.filter(verb => ['POST', 'PUT', 'PATCH'].indexOf(verb) > -1);
			return (filtered.length === 0);
		}

	}

	render() {
		const { sample, codeType } = this.state;
		return (
			<pre className={codeType}>
				<code className={codeType}>
					{sample}
				</code>
			</pre>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		categories: state.api.categories
	};
};

Sample.propTypes = {
	apiItem: PropTypes.object.isRequired,
	categories: PropTypes.array.isRequired
};

export default connect(mapStateToProps)(Sample);


// WEBPACK FOOTER //
// ./src/components/api/Sample.js